const getValidDate = (value: string | number | Date | null | undefined) => {
  if (!value) {
    return null;
  }

  const date = value instanceof Date ? value : new Date(value);
  return Number.isNaN(date.getTime()) ? null : date;
};

export const formatLocalizedDate = (value: string | number | Date | null | undefined) => {
  const date = getValidDate(value);
  if (!date) {
    return "—";
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
  }).format(date);
};

export const formatLocalizedTime = (value: string | number | Date | null | undefined) => {
  const date = getValidDate(value);
  if (!date) {
    return "—";
  }

  return new Intl.DateTimeFormat(undefined, {
    timeStyle: "medium",
  }).format(date);
};

export const formatLocalizedDateTime = (value: string | number | Date | null | undefined) => {
  const date = getValidDate(value);
  if (!date) {
    return "—";
  }

  return new Intl.DateTimeFormat(undefined, {
    dateStyle: "medium",
    timeStyle: "short",
  }).format(date);
};
